import {z} from 'zod';
import {CreateActionCodeRequest} from '../api/generated/index.defs';
import {mapNullToUndefined} from '../utils/zod';

export const actionCodeSchema = z.object({
  sortOrder: mapNullToUndefined(z.number().optional()),
  requireDisposition: mapNullToUndefined(z.boolean().optional()),
  requireLot: mapNullToUndefined(z.boolean().optional()),
  isDefault: mapNullToUndefined(z.boolean().optional()),
  inactive: mapNullToUndefined(z.boolean().optional()),
  description: z.string(),
  color: z.string(),
}) satisfies z.Schema<CreateActionCodeRequest>;

export type ActionCodeSchema = z.TypeOf<typeof actionCodeSchema>;
